import { ACTIVITY_STATE_ALL_VALUE } from "components/filters/ToggleActivityStateFilter";
import { AppList } from "components/list/AppList";
import React, { useState } from "react";
import {
	Datagrid,
	EditButton,
	ReferenceField,
	TextField,
	usePermissions,
	FunctionField,
	useTranslate
} from "react-admin";

import { DatagridWithBlockDeleteProps } from "../../../components/_helpers/props/DatagridProps";
import { stylesForColorInheritInList } from "../../../components/_helpers/useStyles";
import { LinkField } from "../../../components/fields/LinkField";
import { PhoneField } from "../../../components/fields/PhoneField";
import { StyledEmailField } from "../../../components/fields/StyledEmailField";
import { UserTypeField } from "../../../components/fields/UserTypeField";
import { YesNoField } from "../../../components/fields/YesNoField";
import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
import { HideBlockUnblockButtonIfDeleted } from "../../../components/toolbars/BlockUnblockButton";
import DeleteRestoreButtons from "../../../components/toolbars/DeleteRestoreButtons";
import { AppManagerRoles, UserRole } from "../../../entities";
import { isInArray } from "../../../utils/general";
import { CustomerEmployeesActions } from "./Actions";
import { CustomersFilter } from "./ListFilters";
import { CopySettingsButton } from "../../../components/buttons/CopySettingsButton";
import { CopySettingsDialog } from "../../../components/dialogs/CopySettingsDialog";
import { CopyUserSettingsProvider } from "contexts/CopyUserSettingsContext";

const defaultSort = { field: "id", order: "DESC" };
const filterDefaultValues = { activity_state: ACTIVITY_STATE_ALL_VALUE };

export const CustomersList = (props) => {
	const classes = stylesForColorInheritInList();
	const { permissions } = usePermissions();
	const translate = useTranslate();

	return (
		!!permissions && (
			<CopyUserSettingsProvider>
				<CopySettingsDialog />

				<AppList
					{...props}
					sort={defaultSort}
					exporter={false}
					bulkActionButtons={false}
					filters={<CustomersFilter />}
					filterDefaultValues={filterDefaultValues}
					classes={classes}
					actions={<CustomerEmployeesActions />}
				>
					<ScrollingWrapper>
						<Datagrid {...DatagridWithBlockDeleteProps}>
							<TextField source="id" />
							{isInArray(AppManagerRoles, permissions.role) && (
								<ReferenceField reference="companies" source="company_id" link={false}>
									<TextField source="full_name" />
								</ReferenceField>
							)}
							<LinkField source="first_name" />
							<LinkField source="last_name" />
							<StyledEmailField source="email" />
							<PhoneField source="phone" />
							<UserTypeField source="type" sortable={false} />
							<YesNoField source="access_to_export" />

							<FunctionField
								label={translate('pages.settings.name')}
								sortable={false}
								render={(record) => <CopySettingsButton record={record} />}
							/>

							<EditButton label="" />
							<HideBlockUnblockButtonIfDeleted entity={"user"} />
							{permissions.role === UserRole.admin && (
								<DeleteRestoreButtons
									replaceResource="user-is-deleted"
									confirmDeleteStringKey="osfc.dialogs.confirm_delete_user"
									confirmRestoreStringKey="osfc.dialogs.confirm_restore_user"
								/>
							)}
						</Datagrid>
					</ScrollingWrapper>
				</AppList>
			</CopyUserSettingsProvider>
		)
	);
};
